import { apiSlice } from "./baseApi";

apiSlice.injectEndpoints({
  endpoints: builder => ({
    getWeOwe: builder.query({
      query: ({ page = 1, limit = 20 }) => ({ url: `/finance/we-owe?page=${page}&limit=${limit}`, method: "GET" }),
      providesTags: ["Orders", "Invoices", "ServiceItems", "ServiceCompanies", "ServiceTypes", "Customers"],
    }),
    getOwedToUs: builder.query({
      // companyId belongs in the cache key; the API derives its scope from the user.
      query: ({ page = 1, missingPage = 1, limit = 20 }) => ({
        url: `/finance/owed-to-us?page=${page}&missingPage=${missingPage}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["Orders", "Invoices", "ServiceItems", "Customers"],
    }),
  }),
});
